import createFetchClient, { type ClientOptions } from 'openapi-fetch'
import createRQClient from 'openapi-react-query'
import type { paths } from '../../types.cloud.d.ts'

/**
 * Creates a React Query client that talks to the Netdata Cloud API.
 * Quick start:
 *   const rqClient = createCloudQueryClient({ baseUrl: "https://app.netdata.cloud" });
 *   const { data } = rqClient.useQuery("get", "/api/v3/spaces");
 */
export default function createCloudQueryClient(options: ClientOptions = {}) {
    const fetchClient = createFetchClient<paths>(options)

    return createRQClient(fetchClient)
}
